/**                                                                       @about
@file: plugin.sort-table.ts
@desc: Logic for table/sort, built/compiled to ./www
***                                                                           */
import {
  naturalSort,
} from './sort-natural'

/**
 * Our table snatcher, the unsung hero
 * @return {HTMLTableElement | null}
 */
const tableSnatcher = () => document.getElementById('table') as HTMLTableElement | null;

/**
 * Gets the value of a cell in a table row.
 * @param  {HTMLTableRowElement} row - table row element
 * @param  {number} colIndex - index of the cell
 * @return {string | number}
 */
const getCellValue = (row: HTMLTableRowElement, colIndex: number): string | number => {
  const cell: HTMLTableCellElement = row.children[colIndex] as HTMLTableCellElement;
  const dataSortValue = cell.getAttribute('data-sort');
  return (dataSortValue !== null
    ? dataSortValue : cell.innerText || cell.textContent || '').trim();
};

/**
 * Creates a comparison function for sorting table rows
 * @param  {number} colIndex - index of column
 * @param  {boolean} asc - if asc sort
 * @param  {boolean} isRevert = false - if sort is to be reverted
 * @return {(a: HTMLTableRowElement, b: HTMLTableRowElement) => number}
 */
const compareRowsFnFactory = (colIndex: number, asc: boolean, isRevert = false): (a: HTMLTableRowElement, b: HTMLTableRowElement) => number => {
  return isRevert
    ? (a, b) => Number(a.getAttribute('data-idx')) - Number(b.getAttribute('data-idx'))
    : (a, b): number => {
    const cellValue1: string | number = getCellValue(a, colIndex);
    const cellValue2: string | number = getCellValue(b, colIndex);
    return asc ? naturalSort(cellValue1, cellValue2) : naturalSort(cellValue2, cellValue1);
  };
};

/**
 * OnClick/sort logic
 * @param  {MouseEvent} event
 * @return {void}
 */
const onDatClickEvent = (event: MouseEvent, tablePerf = false) => {
  const start = !tablePerf ? 0 : performance.now();
  const table = tableSnatcher()
  if (!table) { return; }
  const cell = event.currentTarget as HTMLTableCellElement;
  const tbody = table.querySelector('tbody');
  const parent = (tbody != null) ? tbody : table;
  const rows: NodeListOf<HTMLTableRowElement> = parent.querySelectorAll('tr:nth-child(n+2)');
  // figure out next state
  const isAsc = !cell.classList.contains('sort-dsc');
  // only filename "unset" sort
  const isRevert = !!cell.classList.length && isAsc && cell.getAttribute('data-id') === 'filename';
  const isDsc = !isRevert && !isAsc;
  // remove/add class
  Array.from(table.rows[0].cells).forEach(val => {
    val.classList.remove('sort-asc', 'sort-dsc')
  });
  !isRevert && cell.classList.add(!isDsc ? 'sort-dsc' : 'sort-asc');
  // sort and build
  const rowsArray = Array.from(rows);
  rowsArray.sort(compareRowsFnFactory(cell.cellIndex, isDsc, isRevert));

  // similar perf profile compared to createDocumentFragment, maybs a touch slower
  for (let i = 0; i < rowsArray.length; i++) {
    parent.appendChild(rowsArray[i]);
  }

  // (rough test of 30000 elms -> 1700ms compared to 1850ms)
  // const fragment = document.createDocumentFragment();
  // for (let i = 0; i < rowsArray.length; i++) {
  //   fragment.appendChild(rowsArray[i]);
  // }
  // parent.replaceChildren(fragment);

  start && requestAnimationFrame(() => { console.log('perf: %d', performance.now() - start ); })
};



/**
 * @INIT -> Wait a sec, so we ain't hot to trot, if surfin' the history
 */
// @ts-expect-error yeah dawg iknow
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
setTimeout(() => {
  const table = tableSnatcher()
  if (!table || !table.rows.length) { return null; }
  const cells: HTMLCollectionOf<HTMLTableCellElement> = table.rows[0].cells;
  for (let c = 0; c < cells.length; c++) {
    cells[c].addEventListener('click', onDatClickEvent)
  }
}, 500)

